import React, { Component } from 'react';
import ConfirmDetails from './pageContents/ConfirmDetails';
import Introductions from './pageContents/Introductions';
import Tests from './pageContents/Tests';
import ConfirmFinish from './pageContents/ConfirmFinish';
import { INTROS } from '../assets/content/intros';
import { TESTS } from '../assets/content/tests';
import HighlightNotes from '../components/staticComponents/HighlightNotes';

class MainContent extends Component {
  state = {
    answeredQuestion: [],
    storedAnswers: [],
    reviewModeNode: []
  }

  storeAnswersWhenTestUnmount = (answeredQuestion, storedAnswers, reviewModeNode) => {
    this.setState({ answeredQuestion, storedAnswers, reviewModeNode });
  }

  renderPageContent() {
    if (this.props.pageType === 'Intro') {
      switch(this.props.pageNumber) {
        case 1:
          return <ConfirmDetails handleClick={this.props.renderNextPage} />;
        case 2:
          return <Introductions
            introductions={INTROS.filter(intro => intro.pageType === 'reading')[0]}
            handleClick={this.props.renderNextPage}
            />;
        default:
          return null;
      }
    } else if (this.props.pageType === 'Tests') {
      return (
        <Tests test={TESTS[this.props.pageNumber - 3]}
          tests={TESTS}
          renderNextPage={this.props.renderNextPage}
          renderPreviousPage={this.props.renderPreviousPage}
          TestsPageJump={this.props.TestsPageJump}
          testPageNumber={this.props.pageNumber - 2}
          storeAnswersWhenTestUnmount={this.storeAnswersWhenTestUnmount}
          answeredQuestion={this.state.answeredQuestion}
          storedAnswers={this.state.storedAnswers}
          reviewModeNode={this.state.reviewModeNode}
        />
      );
    } else {
      return (<ConfirmFinish handleClick={this.props.startReviewAnswers} testEnd={this.props.testEnd} />);
    }
  }

  render() {
    return (
      <div className={`main-content-container ${(this.props.pageType === 'Tests') ? 'full-height' : '' }`}>
       {this.props.pageType === 'Tests' && <HighlightNotes testPageNumber={this.props.pageNumber - 3} />}
       {this.renderPageContent()}
      </div>
    );
  }
}

export default MainContent;
